module.exports = __webpack_public_path__ + "img/cell_size_2.8d9da1b0.svg";